import { useNavigate } from 'react-router';
import configData from '../config.json';
import {useLocation, useParams} from "react-router-dom";

import $ from "jquery"
import { useEffect } from 'react';


const Navbar = ({ category, 
                  categoryList, 
                  setActiveCategory,
                  setActiveVideo
                }) => {

      const location = useLocation();
      let { playlist } = useParams();

    useEffect(() => {

      var pathCat = (playlist).replaceAll('-', ' ');
      var i =0;
      var length = 0;
        {categoryList && categoryList.map((category) => {
            if(pathCat === category.flatName) {
              $('.nav').scrollLeft(length);
            }
            i++;
            length+=$('#'+ category.id).width();
        })};
        
    }, [location]);
                
    const changeActiveCategory = (cat) =>{ 

        var clickedCategory = {};

        categoryList.forEach(element => {
            if(element.id === cat) {
                clickedCategory = element;
            }
        });

        setActiveCategory(clickedCategory);
        setActiveVideo(clickedCategory);
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(clickedCategory));
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(clickedCategory.videos[0]));

        navigateTo(clickedCategory);

    }

    const setClassName = (cat) => {

      if(cat.id === category.id) {
        return "nav-link scrollto active";
      }
      else {
        return "nav-link scrollto";
      }

    };

    let navigate = useNavigate(); 
    const navigateTo = (cat) =>{ 
      var path = '/' + (cat.flatName).replace(/\s/g, '-');
      navigate(path);
    }

    return (
    <>
      <menu className="nav x-scroll" id="nav-horizontal" aria-label="Secondary navigation">
        {categoryList && categoryList.map(( cat, index) => 
                          <a  id={cat.id} key={cat.id} className={setClassName(cat)} href="#home" onClick={() => { changeActiveCategory(cat.id);}}>{cat.name}</a>
                      )}

      </menu>
    </>
    );
  };
  
  export default Navbar;